var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show_nav)?_c('div',[_c('nav-vertical',{scopedSlots:_vm._u([{key:"nav_top",fn:function(){return [_vm._t("nav_top")]},proxy:true},{key:"nav_bottom",fn:function(){return [_vm._t("nav_bottom")]},proxy:true}],null,true)}),_c('global-notification'),_c('update-models')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }